import { render, staticRenderFns } from "./MentoresListaItem.vue?vue&type=template&id=ff9311e2&"
import script from "./MentoresListaItem.vue?vue&type=script&lang=js&"
export * from "./MentoresListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports